import React from 'react';

const HomePriceFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M15.1818 11V19" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M17 12.4546H14.2727C13.9352 12.4546 13.6115 12.5887 13.3728 12.8274C13.1341 13.066 13 13.3898 13 13.7273C13 14.0649 13.1341 14.3886 13.3728 14.6273C13.6115 14.866 13.9352 15 14.2727 15H16.0909C16.4285 15 16.7522 15.1341 16.9909 15.3728C17.2295 15.6115 17.3636 15.9352 17.3636 16.2728C17.3636 16.6103 17.2295 16.934 16.9909 17.1727C16.7522 17.4114 16.4285 17.5455 16.0909 17.5455H13"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.50098 8.91404L9.11352 3.24603C9.62419 2.80829 10.3778 2.80829 10.8884 3.24603L17.501 8.91404"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.4296 8.01051V3.18182C16.4296 3.00099 16.3578 2.82756 16.2299 2.6997C16.102 2.57183 15.9286 2.5 15.7478 2.5H13.7023C13.3258 2.5 13.0205 2.80526 13.0205 3.18182V5.08833"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.95508 16.668V12.3498C7.95508 11.9732 8.26047 11.668 8.63719 11.668H10.0014"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3.57211 8.01172V16.6679" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.16764 16.6668H2.50098" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default HomePriceFilterIcon;
